window.onclick = function(event) {
  try {
    if (!event.target.matches(".no-click")) {
      if (event.target.parentElement.matches(".no-click")) return;
      DisableMenu();
      try {
        if (
          event.target.parentElement.matches(".submenu") ||
          event.target.matches(".submenu")
        )
          return;
        var textBox = document.getElementsByClassName("text-active");
        for (let i = 0; i < textBox.length; i++) {
          if (textBox[i].classList.contains("text-active")) {
            textBox[i].classList.remove("text-active");
          }
        }
      } catch (error) {}
    }
  } catch (err) {}
};

export const DisableMenu = () => {
  var dropdowns = document.getElementsByClassName("dropdown-content");
  var i;
  for (i = 0; i < dropdowns.length; i++) {
    var openDropdown = dropdowns[i];
    if (openDropdown.classList.contains("show")) {
      openDropdown.classList.remove("show");
    }
  }
};
